// extracted by mini-css-extract-plugin
module.exports = {"component":"WhatsInTheBoxSegment-Component-module--component--21BHe"};